export default __webpack_public_path__ + "static/media/bank-building.c91f95b4.svg";